import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
//import 'rxjs/add/operator/toPromise';

import { URL } from '../utilities/url';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Storage } from '@ionic/storage';

@Injectable()
export class RequestService {

    constructor(public alertCtrl: AlertController, private http: HttpClient, private storage: Storage) {
    }

    getHeaders() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        });
    }

    setHeaders(headers): Promise<any> {
        return this.storage.get('token').then((token) => {
            console.log("Token: " + token);
            return headers.set('Content-Type', 'application/json').set('Accept', 'application/json').set('X_JSON_WEB_TOKEN', token);
        });
    }

    // page 1

    requestCode(payload): Observable<any> {
        return this.http.post(URL + 'restUsers/request.json', payload, { headers: this.getHeaders() })
            .pipe(
                retry(2),
                catchError(this.handleError.bind(this))
            );
    }

    loginUser(payload): Observable<any> {
        return this.http.post(URL + 'restUsers/login.json', payload, { headers: this.getHeaders() })
            .pipe(
                retry(2),
                catchError(this.handleError.bind(this))
            );
    }

    async loginByToken(token): Promise<any> {
        return this.http.post(URL + 'restUsers/login/' + token + '/.json', null, { headers: this.getHeaders() })
            .pipe(
                retry(2),
                catchError(this.handleError.bind(this))
            ).toPromise();
    }

    // page 2
    changeNumberUser(payload): Observable<any> {
        return this.http.post(URL + 'restUsers/changeNumber.json', payload, { headers: this.getHeaders() })
            .pipe(
                retry(2),
                catchError(this.handleError.bind(this))
            );
    }

    async updateUser(payload): Promise<any> {

        let headers = new HttpHeaders();
        let data = await this.setHeaders(headers);

        return this.http.post(URL + 'restUsers/update.json', payload, { headers: data })
            .pipe(
                retry(2),
                catchError(this.handleError.bind(this))
            );
    }

    async getSpeciesTypes(payload): Promise<any> {
        let token = await this.storage.get('token');

        return this.http.post(URL + 'restSpeciesTypes/index.json?_token=' + token, payload, { headers: this.getHeaders() })
            .pipe(
                retry(2),
                catchError(this.handleError.bind(this))
            ).toPromise();
    }
    // 3
    async getSpecies(payload): Promise<any> {
        console.log("getSpecies <= " + JSON.stringify(payload));
        let token = await this.storage.get('token');
        return this.http.post(URL + 'restSpecies/index.json?_token=' + token, payload, { headers: this.getHeaders() })
            .pipe(
                retry(2),
                catchError(this.handleError.bind(this))
            ).toPromise();
    }
    async getSpeciesReports(payload): Promise<any> {
        console.log("getSpeciesReports <= " + JSON.stringify(payload));
        let token = await this.storage.get('token');
        return this.http.post(URL + 'restSpeciesReports/index.json?_token=' + token, payload, { headers: this.getHeaders() })
            .pipe(
                retry(2),
                catchError(this.handleError.bind(this))
            ).toPromise();
    }

    async addSpeciesReport(payload): Promise<any> {
        let token = await this.storage.get('token');
        return this.http.post(URL + 'restSpeciesReports/add.json?_token=' + token, payload, { headers: this.getHeaders() })
            .pipe(
                retry(2),
                catchError(this.handleError.bind(this))
            ).toPromise();
    }

    getCatchTypes(): Observable<any> {
        return this.http.post(URL + 'restCatchTypes/index.json', {}, { headers: this.getHeaders() })
            .pipe(
                retry(2),
                catchError(this.handleError.bind(this))
            );
    }

    getDepthRanges(): Observable<any> {
        return this.http.post(URL + 'restDepthRanges/index.json', {}, { headers: this.getHeaders() })
            .pipe(
                retry(2),
                catchError(this.handleError.bind(this))
            );
    }

    async getProjects(): Promise<any> {
        let token = await this.storage.get('token');

        return this.http.post(URL + 'restProjects/index.json?_token=' + token, {}, { headers: this.getHeaders() })
            .pipe(
                retry(2),
                catchError(this.handleError.bind(this))
            ).toPromise();
    }

    async getProjectById(projectId): Promise<any> {
        let token = await this.storage.get('token');

        return this.http.post(URL + 'restProjects/index.json?_token=' + token, {'project_id': projectId}, { headers: this.getHeaders() })
            .pipe(
                retry(2),
                catchError(this.handleError.bind(this))
            ).toPromise();
    }

    async getProjectByName(projectName): Promise<any> {
        let token = await this.storage.get('token');

        return this.http.post(URL + 'restProjects/index.json?_token=' + token, {'project_name': projectName}, { headers: this.getHeaders() })
            .pipe(
                retry(2),
                catchError(this.handleError.bind(this))
            ).toPromise();
    }

    async getMyProjects(): Promise<any> {
        let token = await this.storage.get('token');

        return this.http.post(URL + 'restProjects/index.json?_token=' + token, { 'my_projects': true }, { headers: this.getHeaders() })
            .pipe(
                retry(2),
                catchError(this.handleError.bind(this))
            ).toPromise();
    }

    async getProjectInfo(id): Promise<any> {
        let token = await this.storage.get('token');

        return this.http.post(URL + 'restProjects/info/' + id + '.json?_token=' + token, {}, { headers: this.getHeaders() })
            .pipe(
                retry(2),
                catchError(this.handleError.bind(this))
            ).toPromise();
    }

    async joinProject(id): Promise<any> {
        let token = await this.storage.get('token');

        return this.http.post(URL + 'restProjects/join/' + id + '.json?_token=' + token, {}, { headers: this.getHeaders() })
            .pipe(
                retry(2),
                catchError(this.handleError.bind(this))
            ).toPromise();
    }

    async getAttributes(species_type_id): Promise<any> {
        let token = await this.storage.get('token');

        return this.http.post(URL + 'restAttributes/index/' + species_type_id + '.json?_token=' + token, {}, { headers: this.getHeaders() })
            .pipe(
                retry(2),
                catchError(this.handleError.bind(this))
            ).toPromise();
    }

    async getReportAttributes(report_id): Promise<any> {
        let token = await this.storage.get('token');

        return this.http.post(URL + 'restSpeciesReports/getAttributes/' + report_id + '.json?_token=' + token, {}, { headers: this.getHeaders() })
            .pipe(
                retry(2),
                catchError(this.handleError.bind(this))
            ).toPromise();
    }

    async getReport(report_id): Promise<any> {
        let token = await this.storage.get('token');

        return this.http.post(URL + 'restSpeciesReports/getReport/' + report_id + '.json?_token=' + token, {}, { headers: this.getHeaders() })
            .pipe(
                retry(2),
                catchError(this.handleError.bind(this))
            ).toPromise();
    }

    async sendFeedback(payload): Promise<any> {
        let token = await this.storage.get('token');

        return this.http.post(URL + 'restSpeciesReports/sendFeedback.json?_token=' + token, payload, { headers: this.getHeaders() })
            .pipe(
                retry(2),
                catchError(this.handleError.bind(this))
            ).toPromise();
    }

    async uploadImage(fileToUpload: File, speciesReportId): Promise<any> {
        let token = await this.storage.get('token');

        const formData: FormData = new FormData();
        formData.append('file', fileToUpload, fileToUpload.name);
        return this.http
            .post(URL + 'restSpeciesReports/upload/' + speciesReportId + '.json?_token=' + token, formData)
            .pipe(
                retry(2),
                catchError(this.handleError.bind(this))
            ).toPromise();
    }

    // end
    handleError(error: HttpErrorResponse) {
        console.log("ERROR: ", error);
        if (error.error instanceof ErrorEvent) {
            console.log('An error occurred:', error.message);
            //this.showAlert("Warning", 'An error occurred: ' + error.message);
            this.connectionError();
        } else {
            console.log(`Backend returned code ${error.status}, ` +
                `body was: ${error.message}`);
                this.connectionError();
            //this.showAlert("Warning", 'An error occurred: ' + error.message);
                //+ ', body was: ' + error.message);
        }

        return throwError('error');
        /**
        return throwError(
            'Something bad happened; please try again later.'); 
            */
    }

    async showAlert(header, message) {
        const alert = await this.alertCtrl.create({
            header: header,
            message: message,
            buttons: ['OK']
        });
        await alert.present();
    }

    connectionError() {
        this.showAlert("Warning", 'Connection error. Please try again later.');
    }

}
